// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wx-0";
export var confirmationIcon = "_wx-1";